import React from "react";
import HinbanEntryGridAr from "../../components/HinbanEntryGridAr";

// 加工指示サンプル情報セクション(入力欄・ヘッダ・コメント・明細)の描画をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createSampleSectionRenderer(deps) {
    const {
        DicVal,
        GridData,
        HinbanEntryInput,
        KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID,
        ListRowValueChanged,
        ListValueChanged,
        buildBaseSearchField,
        buildWashGridFunctionRef,
        columninfo,
        columns,
        ensureGridColRef,
        ensureGridDataRef,
        ensureKakousijiSampleGridColRef,
        ensureKakousijiSampleInfoRows,
        entrydataRef,
        entrylock,
        findKakousijiSampleField,
        fnc,
        formid,
        handleKakousijiSampleInfoValueChanged,
        isEmpty,
        kakousijiSampleDetailColumnInfo,
        kakousijiSampleFieldLabel,
        kakousijiSampleFieldSource,
        kakousijiSampleHeaderFields,
        kakousijiSampleSuryoTotal,
        layoutlock,
        onFirstDataRendered,
        registerKakousijiSampleRenderedPanel,
        sectionBodyLocked,
        shouldUseKakousijiDraftNewFormMode,
        syncKakousijiSampleDetailRowsFromPdtc,
        syncKakousijiSampleHeaderValue,
        updateKakousijiSampleComment
    } = deps;

    function renderKakousijiSampleInput(panelInfo, field, dataRef, sectionLock) {
        return (
            <HinbanEntryInput
                def={field}
                dataRef={dataRef}
                textfields={kakousijiSampleFieldSource(panelInfo)}
                fnc={buildWashGridFunctionRef(panelInfo)}
                QuerySearchClick={buildBaseSearchField}
                ValueChanged={(id, value, edit, options) => handleKakousijiSampleInfoValueChanged(panelInfo, id, value, edit, options)}
                sectionLock={sectionLock}
                forceNewFormMode={shouldUseKakousijiDraftNewFormMode(panelInfo)}
                ignoreStoreEntryData={true}
            />
        );
    }
    function renderKakousijiSampleHeaderCell(panelInfo, field, dataRef, sectionLock) {
        if (isEmpty(field)) return <React.Fragment />;
        return (
            <React.Fragment key={field.columnid}>
                <div className="hinban-sample-field-label">{kakousijiSampleFieldLabel(field)}</div>
                <div className="fieldinput hinban-kakousiji-sample-input-cell hinban-sample-field-input">{renderKakousijiSampleInput(panelInfo, field, dataRef, sectionLock)}</div>
            </React.Fragment>
        );
    }
    function renderKakousijiSampleComment(panelInfo, commentField, headerDataRef, locked) {
        const value = DicVal(headerDataRef.current, KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID, '');
        return (
            <textarea
                defaultValue={value}
                placeholder={kakousijiSampleFieldLabel(commentField)}
                readOnly={locked}
                className={locked ? "hinban-sample-comment-textarea hinban-sample-comment-textarea--locked" : "hinban-sample-comment-textarea"}
                onChange={(e) => {
                    headerDataRef.current[KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID] = e.target.value;
                    syncKakousijiSampleHeaderValue(panelInfo, KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID, e.target.value);
                    if (!isEmpty(fnc.current) && typeof fnc.current.modify === 'function') fnc.current.modify(true);
                }}
            />
        );
    }
    function renderKakousijiSampleLowerSection(panelInfo) {
        registerKakousijiSampleRenderedPanel(panelInfo);
        ensureKakousijiSampleInfoRows(panelInfo);
        syncKakousijiSampleDetailRowsFromPdtc(panelInfo, false, 25);
        const commentField = findKakousijiSampleField(panelInfo, KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID);
        const listColumnInfo = kakousijiSampleDetailColumnInfo(columninfo, panelInfo);
        const listColumns = kakousijiSampleDetailColumnInfo(columns, panelInfo);
        const rows = GridData(panelInfo);
        const total = kakousijiSampleSuryoTotal(rows);
        const locked = entrylock || layoutlock || sectionBodyLocked(panelInfo);
        const commentValue = DicVal(entrydataRef.current, KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID, DicVal(DicVal(rows, 0, {}), KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID, ''));
        return (
            <React.Fragment>
                {isEmpty(commentField) ? null : (
                    <div className="hinban-sample-comment-wrap hinban-sample-comment-wrap--spaced">
                        <textarea
                            defaultValue={commentValue}
                            placeholder={kakousijiSampleFieldLabel(commentField)}
                            readOnly={locked}
                            className={locked ? "hinban-sample-comment-textarea hinban-sample-comment-textarea--locked" : "hinban-sample-comment-textarea"}
                            onChange={(e) => updateKakousijiSampleComment(panelInfo, e.target.value)}
                        />
                    </div>
                )}
                <div className="hinban-kakousiji-grid hinban-kakousiji-sample-grid hinban-sample-grid">
                    <HinbanEntryGridAr
                        id={fnc.current.GridID(panelInfo) + '_sample_detail'}
                        entrydataRef={entrydataRef}
                        dataRef={ensureGridDataRef(panelInfo)}
                        columnRef={ensureKakousijiSampleGridColRef(panelInfo)}
                        columninfo={listColumnInfo}
                        columns={listColumns}
                        fnc={buildWashGridFunctionRef(panelInfo)}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={(params) => ListValueChanged(params, panelInfo)}
                        RowValueChanged={(colid, rows) => ListRowValueChanged(colid, rows, panelInfo)}
                        panel={panelInfo}
                        rowDrag={false}
                        disableEntryDataMerge={true}
                    />
                </div>
                <table className="hinban-sample-total-table">
                    <thead>
                        <tr><th className="hinban-sample-total-header">数量計</th></tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="hinban-sample-total-cell"><span className="hinban-sample-total-left">計</span><span className="hinban-sample-total-right">{total === 0 ? '-' : String(total)}</span></td>
                        </tr>
                    </tbody>
                </table>
            </React.Fragment>
        );
    }
    function renderKakousijiSampleInfoSection(panelInfo, filteredColumnInfo, filteredColumns) {
        const rows = ensureKakousijiSampleInfoRows(panelInfo);
        const headerDataRef = { current: rows[0] };
        const headerFields = kakousijiSampleHeaderFields(panelInfo);
        const commentField = findKakousijiSampleField(panelInfo, KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID);
        const listColumnInfo = kakousijiSampleDetailColumnInfo(filteredColumnInfo, panelInfo);
        const listColumns = kakousijiSampleDetailColumnInfo(filteredColumns, panelInfo);
        const locked = entrylock || layoutlock || sectionBodyLocked(panelInfo);
        const total = kakousijiSampleSuryoTotal(rows);
        return (
            <React.Fragment>
                <div className='hinban-kakousiji-sample-info'>
                    <div className="hinban-sample-header-grid">
                        {headerFields.slice(0, 4).map((field) => renderKakousijiSampleHeaderCell(panelInfo, field, headerDataRef, locked))}
                        {headerFields.slice(4, 8).map((field) => renderKakousijiSampleHeaderCell(panelInfo, field, headerDataRef, locked))}
                        {renderKakousijiSampleHeaderCell(panelInfo, headerFields[8], headerDataRef, locked)}
                    </div>
                    {isEmpty(commentField) ? null : (
                        <div className="hinban-sample-comment-wrap">
                            {renderKakousijiSampleComment(panelInfo, commentField, headerDataRef, locked)}
                        </div>
                    )}
                    <div className="hinban-kakousiji-grid hinban-kakousiji-sample-grid hinban-sample-grid">
                        <HinbanEntryGridAr
                            id={fnc.current.GridID(panelInfo)}
                            entrydataRef={entrydataRef}
                            dataRef={ensureGridDataRef(panelInfo)}
                            columnRef={ensureGridColRef(panelInfo)}
                            columninfo={listColumnInfo}
                            columns={listColumns}
                            fnc={buildWashGridFunctionRef(panelInfo)}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            ValueChanged={(params) => ListValueChanged(params, panelInfo)}
                            RowValueChanged={(colid, rows) => ListRowValueChanged(colid, rows, panelInfo)}
                            panel={panelInfo}
                            rowDrag={false}
                        />
                </div>
                    <table className="hinban-sample-total-table">
                        <thead>
                            <tr><th className="hinban-sample-total-header">数量計</th></tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="hinban-sample-total-cell"><span className="hinban-sample-total-left">計</span><span className="hinban-sample-total-right">{total === 0 ? '-' : String(total)}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </React.Fragment>
        );
    }

    return {
        renderKakousijiSampleInput,
        renderKakousijiSampleHeaderCell,
        renderKakousijiSampleComment,
        renderKakousijiSampleLowerSection,
        renderKakousijiSampleInfoSection
    };
}
